export default __webpack_public_path__ + "static/media/demo.e992d213.jpeg";